module.exports = __webpack_public_path__ + "static/img/trackkat-full-logo.svg";